import Vue from 'vue'
import VueSimpleSpinner from 'vue-simple-spinner'
import {Component} from "vue-property-decorator";
import Personalization from "@/components/communications/components/Personalization.vue";
import HttpMixin from "@/mixins/HttpMixin";

@Component({
  components: {
    Personalization,
    VueSimpleSpinner,
  },
  mixins: [HttpMixin],
})
export default class BirthdayMessageCard extends Vue {
  private readonly baseUrl = '/settings/birthday-message';
  private readonly maxLengthParam = 420;
  private birthdayMessage = '';
  private errorMessage = '';
  private updatingParam = false;

  private expandedParam = false;

  // Stupid workaround for stupid typescript
  get cardExpanded(){
    return this.expandedParam;
  }
  get isUpdating(){
    return this.updatingParam;
  }
  get maxLength(){
    return this.maxLengthParam;
  }
  get errorMessageGet() {
    return this.errorMessage;
  }

  async mounted(){
    await this.getMessage();
  }

  async getMessage(){
    try {
      const response = (await this.httpGet(this.baseUrl, 'Failed to load the birthday message')) as any ;
      if(response){
        this.birthdayMessage = response.birthdayMessage;
      }
    }catch (e){
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'Failed to retrieve birthday message.'
      });
    }
  }

  async updateMessage(){
    if (this.birthdayMessage.length > 420) {
      this.errorMessage = 'Message may not be longer than 420 characters';
      return;
    } else {
      this.errorMessage = '';
    }
    this.updatingParam = true;
    try {
      if(await this.httpPost(this.baseUrl, 'Failed to save the birthday message', {'birthdayMessage':this.birthdayMessage})) {
        this.$notify({
          group: 'main',
          type: 'success',
          title: 'Success',
          text: 'Successfully saved the birthday message.'
        });
      }
    }catch (e){
      this.$notify({
        group: 'main',
        type: 'error',
        title: 'Error',
        text: 'Failed to save the birthday message.'
      });
    }
    this.updatingParam = false;
  }

  expandCard(){
    this.expandedParam = !this.expandedParam;
  }

  personalizationSelected(newMessage: string) {
    this.birthdayMessage = newMessage;
  }
  async cancel(){
    await this.getMessage();
  }
}



// WEBPACK FOOTER //
// ./src/components/settings/cards/BirthdayMessage/BirthdayMessageCard.ts